/* ============================================================
   「商品を表示」アコーディオン（ゲームタイトル・予算・見た目・購入前チェック）

   <details> ではなく button[aria-expanded] ＋ パネルの開示パターンで組む。
   パネルは一覧（.game-list / .banner-list）の直下（カードの兄弟）にあり、
   PC では grid-column: 1 / -1 で3カラムの下に全幅で開く（mdl-lp.css）。
   全幅パネルが複数開くと縦に伸びるので、PC では一覧ごとに1つだけ開く。

   開閉は height を実測してアニメーションさせる。display:none のままでは
   transition が走らないので、開く前に hidden を外し、閉じ切ってから戻す。

   元実装から変えた点:
   - ボタンの収集を静的な querySelectorAll から document への委譲に変更。
     テーマエディタはセクション単位で再描画するため、読み込み時に集めた
     参照はすぐ古くなる。委譲なら再描画後のボタンにもそのまま効く。
   - パネルに data-src があるときは、初回展開時にその URL を取得して差し込む。
     予算帯などを「1コレクション＋タグ」のURLで運用するため。
     取得し終えてから高さを測り直す。
   ============================================================ */
(function () {
  'use strict';
  /* 同じスクリプトを複数セクションが読み込むため <script> は何本も出力される。
     ブラウザはタグごとに実行するので、ガードが無いと処理が重複する
     （アコーディオンなら開閉が複数回走り、偶数回で閉じたままになる）。 */
  if (window.mdlLpAccordionReady) return;
  window.mdlLpAccordionReady = true;


  var FALLBACK_MS = 400;   // transitionend が来なかったときの保険（CSSは0.25s）
  var LIST = '.game-list, .banner-list, .check-list--full';
  var pc = window.matchMedia('(min-width: 1024px)');

  function listOf(btn) { return btn.closest(LIST); }
  function panelOf(btn) { return document.getElementById(btn.getAttribute('aria-controls')); }
  function isOpen(btn) { return btn.getAttribute('aria-expanded') === 'true'; }

  function allButtons() {
    return Array.prototype.slice.call(
      document.querySelectorAll('.acc__btn[aria-controls], .check__btn[aria-controls]'));
  }

  /** 高さのアニメーションだけを担当する */
  function animate(panel, open) {
    if (panel.cleanup) panel.cleanup();

    function finish() {
      clearTimeout(panel.timer);
      panel.removeEventListener('transitionend', onEnd);
      panel.classList.remove('acc__panel--animating');
      panel.style.height = '';        // 開いた後は auto に戻す（リサイズに追従させる）
      panel.cleanup = null;
      if (!open) panel.hidden = true;
    }

    function onEnd(e) {
      if (e.target === panel && e.propertyName === 'height') finish();
    }

    panel.cleanup = finish;
    panel.classList.add('acc__panel--animating');
    if (open) panel.hidden = false;

    panel.style.height = (open ? 0 : panel.scrollHeight) + 'px';
    void panel.offsetHeight;          // 開始値を確定させてから目標値へ
    panel.style.height = (open ? panel.scrollHeight : 0) + 'px';

    panel.addEventListener('transitionend', onEnd);
    panel.timer = setTimeout(finish, FALLBACK_MS);
  }

  /** data-src の中身を1回だけ取りに行く。取得後に高さを測り直す */
  function loadRemote(panel) {
    var url = panel.getAttribute('data-src');
    if (!url || panel.dataset.loaded === 'true' || panel.dataset.loading === 'true') return;
    panel.dataset.loading = 'true';
    if (!panel.innerHTML.trim()) {
      panel.innerHTML = '<p class="mdl-lp__empty">読み込み中…</p>';
    }

    var joiner = url.indexOf('?') === -1 ? '?' : '&';
    fetch(url + joiner + 'view=mdl-lp-grid', { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        panel.innerHTML = html;
        panel.dataset.loaded = 'true';
        // 中身が増えた分だけ高さを合わせ直す（開いている間だけ）
        if (!panel.hidden) {
          panel.style.height = panel.scrollHeight + 'px';
          setTimeout(function () { panel.style.height = ''; }, 260);
        }
      })
      .catch(function () {
        panel.innerHTML = '<p class="mdl-lp__empty">商品を読み込めませんでした。時間をおいてお試しください。</p>';
        panel.dataset.loaded = 'true';
        if (!panel.hidden) panel.style.height = '';
      })
      .then(function () { panel.dataset.loading = 'false'; });
  }

  /** パネル内の画像を今すぐ読み込ませる。
      hidden の間は loading="lazy" が効いて読み込みが始まらないため、
      開く直前に eager へ切り替えて待ち時間を前倒しする */
  function warmImages(panel) {
    Array.prototype.slice.call(panel.querySelectorAll('img[loading="lazy"]')).forEach(function (img) {
      img.loading = 'eager';
      if (img.decode) img.decode().catch(function () {});
    });
  }

  /** 開く意思が見えた時点（hover/focus/touch）で取得と画像読み込みを始める */
  function warm(btn) {
    var panel = panelOf(btn);
    if (!panel || panel.dataset.warmed === 'true') return;
    panel.dataset.warmed = 'true';
    loadRemote(panel);
    warmImages(panel);
  }

  function setOpen(btn, open) {
    btn.setAttribute('aria-expanded', String(open));
    var panel = panelOf(btn);
    if (!panel) return;
    if (open) {
      loadRemote(panel);
      warmImages(panel);
    }
    animate(panel, open);
  }

  /** 同じ一覧の中で、current 以外の開いているものを閉じる */
  function closeSiblings(current) {
    var list = listOf(current);
    if (!list) return;
    allButtons().forEach(function (other) {
      if (other !== current && listOf(other) === list && isOpen(other)) setOpen(other, false);
    });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('.acc__btn[aria-controls], .check__btn[aria-controls]');
    if (!btn) return;
    var open = !isOpen(btn);
    setOpen(btn, open);
    if (open && pc.matches) closeSiblings(btn);
  });

  /* 押す前に準備を始める。pointerenter はPCのホバー、touchstart はタップの押し込み、
     focusin はキーボード操作を拾う。いずれも実際に開く前に発火する */
  ['pointerenter', 'touchstart', 'focusin'].forEach(function (type) {
    document.addEventListener(type, function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      var btn = target.closest('.acc__btn[aria-controls], .check__btn[aria-controls]');
      if (btn) warm(btn);
    }, { capture: true, passive: true });
  });

  /* 画面に入った一覧は、空き時間に先読みしておく */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        io.unobserve(entry.target);
        var run = window.requestIdleCallback || function (fn) { setTimeout(fn, 200); };
        run(function () { warm(entry.target); });
      });
    }, { rootMargin: '200px' });
    var observeAll = function () { allButtons().forEach(function (b) { io.observe(b); }); };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observeAll);
    } else {
      observeAll();
    }
  }

  /* モバイルで複数開いたまま PC 幅にリサイズしたら、一覧ごとに最初の1つだけ残す */
  pc.addEventListener('change', function (e) {
    if (!e.matches) return;
    var seen = [];
    allButtons().filter(isOpen).forEach(function (btn) {
      var list = listOf(btn);
      if (!list) return;
      if (seen.indexOf(list) === -1) seen.push(list);
      else setOpen(btn, false);
    });
  });
}());
